module.exports = __webpack_public_path__ + "media/explosionCrunch_000.6f6b09b1.ogg";